(function() {
  var dataEl = document.getElementById('docfinder-data');
  var documents = dataEl ? JSON.parse(dataEl.textContent) : [];

  documents.sort(function(a, b) {
    var aP = (a.priority == null) ? 99 : a.priority;
    var bP = (b.priority == null) ? 99 : b.priority;
    var diff = aP - bP;
    if (diff !== 0) return diff;
    return (a.title || '').localeCompare(b.title || '', 'de');
  });

  var modelSelect = document.getElementById('docfinder-model');
  var categorySelect = document.getElementById('docfinder-category');
  var resultsWrap = document.getElementById('docfinder-results-wrap');
  var resultsEl = document.getElementById('docfinder-results');
  var emptyEl = document.getElementById('docfinder-empty');
  var modal = document.getElementById('docfinder-modal');
  var modalContent = document.getElementById('docfinder-modal-content');
  var closeBtn = modal.querySelector('.docfinder-close');
  var overlay = modal.querySelector('.docfinder-modal-overlay');

  function uniqueValues(key) {
    var seen = {};
    var result = [];
    for (var i = 0; i < documents.length; i++) {
      var val = documents[i][key];
      if (Array.isArray(val)) {
        for (var k = 0; k < val.length; k++) {
          if (val[k] && !seen[val[k]]) {
            seen[val[k]] = true;
            result.push(val[k]);
          }
        }
      } else if (val && !seen[val]) {
        seen[val] = true;
        result.push(val);
      }
    }
    return result.sort(function(a, b) { return a.localeCompare(b, 'de'); });
  }

  function populateSelect(select, values) {
    for (var i = 0; i < values.length; i++) {
      var option = document.createElement('option');
      option.value = values[i];
      option.textContent = values[i];
      select.appendChild(option);
    }
  }

  function populateModelSelect(select) {
    var groupsByProduct = {};
    var priorityByProduct = {};
    var productOrder = [];
    for (var i = 0; i < documents.length; i++) {
      var variants = documents[i].variants || [];
      for (var j = 0; j < variants.length; j++) {
        var v = variants[j];
        if (!groupsByProduct[v.product]) {
          groupsByProduct[v.product] = {};
          var parsed = parseInt(v.priority, 10);
          priorityByProduct[v.product] = isNaN(parsed) ? 99 : parsed;
          productOrder.push(v.product);
        }
        groupsByProduct[v.product][v.key] = v.label;
      }
    }
    productOrder.sort(function(a, b) {
      var diff = priorityByProduct[a] - priorityByProduct[b];
      if (diff !== 0) return diff;
      return a.localeCompare(b, 'de');
    });

    for (var p = 0; p < productOrder.length; p++) {
      var productTitle = productOrder[p];
      var variantMap = groupsByProduct[productTitle];
      var keys = Object.keys(variantMap).sort(function(a, b) {
        return (variantMap[a] || '').localeCompare(variantMap[b] || '', 'de');
      });

      if (keys.length === 1 && variantMap[keys[0]] === '') {
        var opt = document.createElement('option');
        opt.value = keys[0];
        opt.textContent = productTitle;
        select.appendChild(opt);
      } else {
        var group = document.createElement('optgroup');
        group.label = productTitle;
        for (var k = 0; k < keys.length; k++) {
          var optEl = document.createElement('option');
          optEl.value = keys[k];
          optEl.textContent = variantMap[keys[k]] || productTitle;
          group.appendChild(optEl);
        }
        select.appendChild(group);
      }
    }
  }

  function getVideoEmbed(url) {
    var lower = url.toLowerCase();

    if (lower.includes('youtube.com/watch?v=')) {
      return '<iframe src="' + url.replace('watch?v=', 'embed/') + '" allowfullscreen></iframe>';
    }

    if (lower.includes('youtu.be/')) {
      return '<iframe src="' + url.replace('youtu.be/', 'youtube.com/embed/') + '" allowfullscreen></iframe>';
    }

    if (lower.includes('vimeo.com')) {
      var match = url.match(/vimeo\.com\/(\d+)/);
      if (match && match[1]) {
        return '<iframe src="https://player.vimeo.com/video/' + match[1] + '" allowfullscreen></iframe>';
      }
    }

    // Default: direct video file (Shopify CDN, .mp4, etc.)
    return '<video controls autoplay playsinline preload="metadata"><source src="' + url + '" type="video/mp4"></video>';
  }

  function openModal(url) {
    modalContent.innerHTML = getVideoEmbed(url);
    modal.classList.add('is-active');
    document.documentElement.style.overflow = 'hidden';
  }

  function closeModal() {
    modal.classList.remove('is-active');
    document.documentElement.style.overflow = '';
    setTimeout(function() { modalContent.innerHTML = ''; }, 400);
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  function renderResults(items) {
    resultsEl.innerHTML = '';
    resultsWrap.style.display = 'block';

    if (!items.length) {
      emptyEl.style.display = 'block';
      return;
    }

    emptyEl.style.display = 'none';

    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var card = document.createElement('div');
      card.className = 'docfinder-card';

      var actions;
      if (item.type === 'video') {
        actions =
          '<div class="docfinder-actions">' +
            '<button class="docfinder-link" data-video="' + escapeHtml(item.url) + '">Video abspielen</button>' +
            '<a class="docfinder-play" href="' + escapeHtml(item.url) + '" download rel="noopener">Download</a>' +
          '</div>';
      } else {
        actions =
          '<div class="docfinder-actions">' +
            '<a class="docfinder-link" href="' + escapeHtml(item.url) + '" target="_blank" rel="noopener">PDF öffnen</a>' +
            '<a class="docfinder-play" href="' + escapeHtml(item.url) + '" download rel="noopener">Download</a>' +
          '</div>';
      }

      var modelBadges = (item.models || []).map(function(m) {
        return '<span class="docfinder-badge">' + escapeHtml(m) + '</span>';
      }).join('');

      card.innerHTML =
        '<div class="docfinder-badges">' +
          '<span class="docfinder-badge">' + escapeHtml(item.type.toUpperCase()) + '</span>' +
          modelBadges +
          '<span class="docfinder-badge">' + escapeHtml(item.category) + '</span>' +
        '</div>' +
        '<h3>' + escapeHtml(item.title) + '</h3>' +
        '<p>' + escapeHtml(item.description || '') + '</p>' +
        actions;

      resultsEl.appendChild(card);
    }

    var videoButtons = resultsEl.querySelectorAll('[data-video]');
    for (var j = 0; j < videoButtons.length; j++) {
      videoButtons[j].addEventListener('click', function() {
        openModal(this.getAttribute('data-video'));
      });
    }
  }

  function filterDocuments() {
    var selectedModel = modelSelect.value;
    var selectedCategory = categorySelect.value;

    var filtered = documents.filter(function(item) {
      var modelMatch = !selectedModel || (item.variants || []).some(function(v) {
        return v.key === selectedModel;
      });
      var categoryMatch = !selectedCategory || item.category === selectedCategory;
      return modelMatch && categoryMatch;
    });

    renderResults(filtered);
  }

  populateModelSelect(modelSelect);
  populateSelect(categorySelect, uniqueValues('category'));

  modelSelect.addEventListener('change', filterDocuments);
  categorySelect.addEventListener('change', filterDocuments);

  // Show all results on load
  filterDocuments();
  closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', closeModal);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.classList.contains('is-active')) {
      closeModal();
    }
  });
})();
